/**
 * Карточка задачи в отчётности открывается там, где её нажали (§25.7):
 * поверх раздела «Задачи», «Требует внимания» или детализации сотрудника
 * и проекта — отчёт под ней остаётся смонтированным.
 *
 * Прежде карточка жила только в разделе «Задачи», и задача из детализации
 * сотрудника уводила в общий список, а из других разделов — на доску.
 *
 * Адрес карточки — адрес раздела плюс «/tasks/:taskKey»; у самого раздела
 * «Задачи» — просто «/reports/tasks/:taskKey».
 */

const REPORT_TASK = /^(\/reports(?:\/.*)?)\/tasks\/[^/]+$/;

/** Адрес карточки задачи поверх раздела отчёта. */
export function reportTaskPath(section: string, taskKey: string): string {
  return section === "/reports/tasks" ? `${section}/${taskKey}` : `${section}/tasks/${taskKey}`;
}

/**
 * Раздел отчёта, поверх которого открыта карточка: туда она возвращается
 * при закрытии, там же открываются связанные задачи. null — не отчёт.
 */
export function reportTaskSection(pathname: string): string | null {
  const match = REPORT_TASK.exec(pathname);
  if (match?.[1] === undefined) return null;
  return match[1] === "/reports" ? "/reports/tasks" : match[1];
}
